import { createSelector } from '@reduxjs/toolkit';
import { localStorageService, StorageKeys } from '@ibk/shared-utils';
const selectUserState = (state) => state.user;
export const selectCurrentUser = createSelector([selectUserState], userState => userState.currentUser);
export const selectUserMetadata = createSelector([selectCurrentUser], currentUser => currentUser?.metadata ?? null);
export const selectUserFullName = createSelector([selectCurrentUser], currentUser => {
    if (!currentUser)
        return null;
    return `${currentUser.firstName} ${currentUser.lastName}`.trim();
});
export const selectUserAvailableApps = createSelector([selectUserMetadata], metadata => metadata?.availableApps ?? []);
export const selectUserLoading = createSelector([selectUserState], userState => userState.loading);
export const selectUserError = createSelector([selectUserState], userState => userState.error);
export const selectIsUserLoaded = createSelector([selectCurrentUser], currentUser => currentUser !== null);
export const selectUserDocumentInfo = createSelector([selectCurrentUser], currentUser => currentUser
    ? {
        documentType: currentUser.documentType,
        documentNumber: currentUser.documentNumber,
    }
    : null);
export const selectUserEmployeeId = createSelector([selectUserMetadata], metadata => metadata?.employeeId ?? null);
export const selectSelectedAccountId = createSelector([selectUserState], userState => userState.selectedAccountId);
export const selectSelectedAccount = createSelector([selectUserState], userState => userState.selectedAccount);
function getAccountsFromLocalStorage() {
    try {
        const accounts = localStorageService.getItemSync(StorageKeys.AllAccounts);
        return accounts || [];
    }
    catch (error) {
        return [];
    }
}
export const selectSelectedCompanyOrgId = createSelector([selectSelectedAccountId, (state) => state.baseApi?.queries], (selectedAccountId, queries) => {
    if (!selectedAccountId)
        return null;
    const personAccessData = queries?.['getPersonAccesses(undefined)']?.data;
    if (personAccessData?.result) {
        const selectedCompany = personAccessData.result.find((item) => item.targetId === selectedAccountId);
        if (selectedCompany?.entity?.id) {
            return selectedCompany.entity.id;
        }
    }
    const accounts = getAccountsFromLocalStorage();
    const selectedAccount = accounts.find((item) => item.id === selectedAccountId);
    if (selectedAccount?.entityId) {
        return selectedAccount.entityId;
    }
    return null;
});
export const selectSelectedCompanyDocument = createSelector([selectSelectedAccountId, (state) => state.baseApi?.queries], (selectedAccountId, queries) => {
    if (!selectedAccountId)
        return null;
    const personAccessData = queries?.['getPersonAccesses(undefined)']?.data;
    if (personAccessData?.result) {
        const selectedCompany = personAccessData.result.find((item) => item.targetId === selectedAccountId);
        if (selectedCompany?.entity?.documentNumber) {
            return selectedCompany.entity.documentNumber;
        }
    }
    const accounts = getAccountsFromLocalStorage();
    const selectedAccount = accounts.find((item) => item.id === selectedAccountId);
    if (selectedAccount?.documentNumber) {
        return selectedAccount.documentNumber;
    }
    return null;
});
export const selectSelectedCompanyPartyId = createSelector([selectSelectedAccountId, (state) => state.baseApi?.queries], (selectedAccountId, queries) => {
    if (!selectedAccountId)
        return null;
    const personAccessData = queries?.['getPersonAccesses(undefined)']?.data;
    if (personAccessData?.result) {
        const selectedCompany = personAccessData.result.find((item) => item.targetId === selectedAccountId);
        if (selectedCompany?.entity?.party?.id) {
            return selectedCompany.entity.party.id;
        }
    }
    return null;
});
export const selectAuthorizationOwnerPartyId = createSelector([selectSelectedAccountId, (state) => state.baseApi?.queries], (selectedAccountId, queries) => {
    if (!selectedAccountId)
        return null;
    const personAccessData = queries?.['getPersonAccesses(undefined)']?.data;
    if (personAccessData?.result) {
        const selectedCompany = personAccessData.result.find((item) => item.targetId === selectedAccountId);
        if (selectedCompany?.authorizationOwnerPartyId) {
            return selectedCompany.authorizationOwnerPartyId;
        }
    }
    const accounts = getAccountsFromLocalStorage();
    const selectedAccount = accounts.find((item) => item.id === selectedAccountId);
    if (selectedAccount?.authorizationOwnerPartyId) {
        return selectedAccount.authorizationOwnerPartyId;
    }
    return null;
});
